/* tslint:disable */
/* eslint-disable */
/**
 * Rejeem API
 * Rejeem API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { MembershipResponse } from './membership-response';
// May contain unused imports in some cases
// @ts-ignore
import { SubscriptionDetailResponse } from './subscription-detail-response';

/**
 * 
 * @export
 * @interface UserResponse
 */
export interface UserResponse {
    /**
     * 
     * @type {string}
     * @memberof UserResponse
     */
    'fullName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserResponse
     */
    'gender'?: UserResponseGenderEnum;
    /**
     * 
     * @type {string}
     * @memberof UserResponse
     */
    'birthDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof UserResponse
     */
    'height'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserResponse
     */
    'weight'?: number;
    /**
     * 
     * @type {string}
     * @memberof UserResponse
     */
    'dietType'?: UserResponseDietTypeEnum;
    /**
     * 
     * @type {Set<string>}
     * @memberof UserResponse
     */
    'allergens'?: Set<string>;
    /**
     * 
     * @type {Set<string>}
     * @memberof UserResponse
     */
    'medicalConditions'?: Set<string>;
    /**
     * 
     * @type {Set<string>}
     * @memberof UserResponse
     */
    'roles'?: Set<string>;
    /**
     * 
     * @type {SubscriptionDetailResponse}
     * @memberof UserResponse
     */
    'activeSubscription'?: SubscriptionDetailResponse;
    /**
     * 
     * @type {string}
     * @memberof UserResponse
     */
    'deliveryPhoneNumber'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserResponse
     */
    'mainUser'?: boolean;
    /**
     * 
     * @type {MembershipResponse}
     * @memberof UserResponse
     */
    'membership'?: MembershipResponse;
}

export const UserResponseGenderEnum = {
    Male: 'MALE',
    Female: 'FEMALE'
} as const;

export type UserResponseGenderEnum = typeof UserResponseGenderEnum[keyof typeof UserResponseGenderEnum];
export const UserResponseDietTypeEnum = {
    LowCarb: 'LOW_CARB',
    Balanced: 'BALANCED',
    Vegan: 'VEGAN',
    HighProtein: 'HIGH_PROTEIN',
    Keto: 'KETO',
    GlutenFree: 'GLUTEN_FREE'
} as const;

export type UserResponseDietTypeEnum = typeof UserResponseDietTypeEnum[keyof typeof UserResponseDietTypeEnum];


